import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './styles.scss';

const FilePicker = (props) => {
  const { t } = useTranslation();

  const fileInputRef = React.useRef();

  const handleDivClick = () => {
    if (fileInputRef.current) {
      // Allow selecting the same file multiple times by resetting the input value
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e?.target?.files?.[0];
    if (!selectedFile) {
      return;
    }
    if (props.onFileSelected) {
      props.onFileSelected(selectedFile);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      // Create a synthetic event to match input's onChange signature
      if (props.onFileSelected) {
        props.onFileSelected(e.dataTransfer.files[0]);
      }
      e.dataTransfer.clearData();
    }
  };

  return (
    <div
      className={classNames({ [styles.filepickerResponsiveModal]: props.isResponsiveModal }, styles.filePickerContainer)}
      onClick={handleDivClick}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onKeyPress={handleDivClick}
      role='button'
      tabIndex='0'
      id={props.container}
    >
      <div className={styles.filePickerContent}>
        <span className={styles.uploadIcon} aria-label="Upload" />
        <p>{t('cards.recordings.filePicker.prompt')}</p>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept={props.acceptedFileTypes}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
};

FilePicker.propTypes = {
  acceptedFileTypes: PropTypes.string,
  onFileSelected: PropTypes.func.isRequired,
  container: PropTypes.string,
  containerClass: PropTypes.string,
  isResponsiveModal: PropTypes.bool
};

FilePicker.defaultProps = {
  acceptedFileTypes: '',
  container: '',
  containerClass: '',
  isResponsiveModal: false
};

export default FilePicker;
